<template>
  <!--足あと営業-->
  <div class="w-11/12 flex flex-col mb-6 md:mb-12">
    <sub-head1 :mainText="title" :subText="subTitle" />
    <div class="video_container">
      <iframe
        width="560"
        :src="url"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import SubHead1 from '../components/SubHead1.vue'
export default defineComponent({
  name: 'YoutubeView',
  props: {
    title: {
      type: String,
      require: true,
      default: ``,
    },
    subTitle: {
      type: String,
      require: true,
      default: ``,
    },
    url: {
      type: String,
      require: true,
      default: `https://www.youtube.com/embed/X1GaU1N7-lY?si=R1v94sQDbm8xjh0p`,
    },
  },
  components: { SubHead1 },
})
</script>

<style scoped>
.video_container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0px;
  overflow: hidden;
}
.video_container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
